


























































































































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import AuthConnector from '@/connector/Auth.vue';
import UserService from '@/services/UserService';

@Component({
  components: {
    AuthConnector,
  },
})
export default class LoginDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  private userService = new UserService();

  public username: string = '';

  public password: string = '';

  public bank: string = '';

  public accountNumber: string = '';

  public knownUsFrom: string = '';

  public accountName: string = '';

  public loading: boolean = false;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  public async registerUser() {
    const refCode = await localStorage.getItem('betflix8k-affiliate-program-reference');
    try {
      this.loading = true;
      // eslint-disable-next-line max-len
      await this.userService.registerUser({
        username: this.username,
        password: this.password,
        accountNumber: this.accountNumber.trim(),
        bank: this.bank,
        accountName: this.accountName,
        knownUsFrom: this.knownUsFrom,
        // eslint-disable-next-line @typescript-eslint/camelcase
        ref_code: refCode,
      });
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: 'สมัครสามาชิกสำเร็จ', error: false });
      this.close();
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
      this.loading = false;
    }
  }
}
